type Listener = () => void

let bump1 = false
let bump2 = false
let popupOpen = false
const listeners: Set<Listener> = new Set()

function getCheckoutUrl(): string {
  if (bump1 && bump2) {
    return 'https://homemasterglobal.com/cart/43629381582926:1'
  }
  if (bump1) {
    return 'https://homemasterglobal.com/cart/43629159383118:1'
  }
  if (bump2) {
    return 'https://homemasterglobal.com/cart/43629379649614:1'
  }
  return 'https://homemasterglobal.com/cart/43531718492238:1'
}

function getTotalPrice(): number {
  const base = 6.39
  return base + (bump1 ? 7.0 : 0) + (bump2 ? 9.0 : 0)
}

function setBumps(b1: boolean, b2: boolean) {
  bump1 = b1
  bump2 = b2
  listeners.forEach((fn) => fn())
}

function getBumps() {
  return { bump1, bump2 }
}

function getPopupOpen() {
  return popupOpen
}

function setPopupOpen(open: boolean) {
  popupOpen = open
  listeners.forEach((fn) => fn())
}

function subscribe(fn: Listener) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export {
  getCheckoutUrl,
  getTotalPrice,
  setBumps,
  getBumps,
  getPopupOpen,
  setPopupOpen,
  subscribe,
}
